import React, {useState, useEffect} from "react";
import assets from "../assets/imgs";
import BoardWriteBox from "./BoardWriteBox";
import config from "../config/config";
const API_URL = config.API_URL;

function MyPagePlan({style}) {
  
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const handleClick = (_id) =>{
    setSelectedId(_id);
    setIsModalOpen(true);
  }

  const handleClose = ()=>{
    setIsModalOpen(false);
  }

  const currentDate = new Date();
  const formatDate = (date) => {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
  };

  const [currentMonth, setCurrentMonth] = useState(
    formatDate(new Date(
      currentDate.getFullYear(), currentDate.getMonth(), 1
    ))
  );

  // API 호출 함수
  const fetchData = async () => {
    try {
      const response = await fetch(`${API_URL}/api/board/getPlanList`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body:JSON.stringify({
          currentMonth : currentMonth,
          mypage : true,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      // console.log(result.value);

      if (result.result && Array.isArray(result.value)) {
        // 데이터를 변환하여 company -> startup_name 매핑
        const formattedData = result.value.map((row, index) => ({
          _id: row._id || index + 1, // ID 설정
          id: index + 1,
          title : row.title || '-',
          start_date : row.start_date ? row.start_date.split("T")[0]: "-",
          end_date : row.end_date ? row.end_date.split("T")[0]: "-",
        }));
        setData(formattedData);
      } else {
        console.error("데이터 가져오기 실패:", result.message);
      }
    } catch (error) {
      console.error("Error fetching board data:", error);
      // setError(error.message); // 에러 메시지 저장
    } finally {
      setLoading(false); // 데이터 로딩 완료
    }
  };
  useEffect(() => {
    fetchData();
  }, [currentMonth]);

  // const programs = [
  //   { id: 1, name: "프로그램 A", startDate: "2024-05-05", endDate: "2024-12-23" },
  //   { id: 2, name: "프로그램 B", startDate: "2024-05-05", endDate: "2025-01-07" },
  //   { id: 3, name: "프로그램 C", startDate: "2024-05-05", endDate: "2025-01-09" },
  //   { id: 4, name: "프로그램 D", startDate: "2024-05-05", endDate: "2025-01-10" },
  // ];
  const maxDisplay = 4;

  const calculateDDay = (endDate) => {
    const today = new Date(); // 현재 날짜
    const targetDate = new Date(endDate); // 완료 날짜
    const difference = Math.ceil((targetDate - today) / (1000 * 60 * 60 * 24)); // 일 수 계산

    if (difference > 0) return `D-${difference}`; // 남은 일수
    if (difference === 0) return "D-Day"; // 오늘
    return `D+${Math.abs(difference)}`; // 지난 날짜
  };

   // 완료 날짜를 기준으로 오래된 순으로 정렬
   const sortedPrograms = [...data].sort((a, b) => new Date(a.end_date) - new Date(b.end_date));

  return (
    <>
      {loading ? (
        <p>Loading...</p>
      ):(
        <>
          <div className="commonComponent" style={{...style, padding: "32px 32px 0px 32px"}}>
            <div style={styles.header}>
              <h2 className="font-s-head4-bold">일정관리</h2>
              <img className="icon-plus" src={assets.icons.plus} onClick={() => {}}/>
            </div>
            <div style={styles.contents}>
              {sortedPrograms.slice(0, maxDisplay).map((program, index) => (
                <div key={program._id} style={{
                  ...styles.card,
                  ...(index === maxDisplay - 2 ? { opacity:  0.8} : {}),
                  ...(index === maxDisplay - 1 ? { opacity:  0.1} : {}), // 마지막 카드에만 적용
                  }} onClick={() => handleClick(program._id)}>
                  {/* D-Day 표시 */}
                  <div style={styles.cardLeft}>
                    <div style={styles.info}>
                      <div className="font-body4-semibold" style={
                          {...styles.dDay,
                          ...(index === 0 ? styles.firstDDay : {}) }
                        }>
                        {calculateDDay(program.end_date)}
                      </div>
                      <div className="font-body2-semibold" style={styles.programName}>{program.title}</div>
                    </div>              
                    <div className="font-body4-medium" style={styles.period}>프로그램 기간 : {program.start_date} - {program.end_date} </div>
                  </div>
                  {/* 메뉴 버튼 */}
                  <img className="icon-kebab" src={assets.icons.kebab}/>
                </div>
              ))}
            </div>
          </div>
          {isModalOpen && (
            <BoardWriteBox boardTypeId={"Plan"} boardTypeName={"일정"} onClose={handleClose} boardId={selectedId} edit={false}/>
          )}
        </>
       
      )}
    </>
  );
}
const styles ={
  header: {
    display: "flex",
    justifyContent:"space-between",
    alignItems:"center",
    marginBottom: "20px",
  },
  contents: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  card: {
    boxSizing: "border-box",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "18px 20px 12px 20px",
    borderRadius: "4px",
    backgroundColor: "#fff",
    boxShadow: "0px 4px 8px 0px rgba(157, 163, 191, 0.10)",
    borderLeft: "3px solid var(--primary-crimson_30)",
    cursor:"pointer"
  },
  cardLeft: {
    flex: "1",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "8px",
  },
  dDay: {
    backgroundColor: "var(--main-orange_10)",
    padding: "4px 12px",
    borderRadius: "16px",
    color: "var(--main-orange_70)",
  },
  firstDDay:{
    backgroundColor: "var(--main-red_10)",
    color: "var(--main-red_70)",
  },
  // dDayText: {
  //   color: "#D22E59",
  // },
  info: {
    display: "flex",
    gap: "8px",
  },
  programName: {
    color: "var(--grayscale_100)",
    display: "flex",
    alignItems: "center",

  },
  period: {
    color: "var(--grayscale_80)",
  },
}
export default MyPagePlan;